/**
 * Created by Bart Decorte
 * Date: 08/02/2022
 * Time: 14:24
 */

function imageRules() {
  return {
    'image/jpeg': {
      maxSize: 16 * 1000 * 1000, // 16 MB
      maxSide: 6000, // px
    },
    'image/png': {
      maxSize: 16 * 1000 * 1000, // 16 MB
      maxSide: 4000, // px
    },
    'image/gif': {
      maxSize: 8 * 1000 * 1000, // 8 MB
      maxSide: 1000, // px
    },
  };
}

export { imageRules };



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/validation_helper.js